module.exports = __webpack_public_path__ + "static/64-4f4f024c44988c7789357427d89118c0.png";